module.exports = __webpack_public_path__ + "img/promotion-1.c54c95b6.png";